// =====================================================================
// unsereHochzeits.app – ErrorBoundary
// Fängt Runtime-Fehler in der Render-Phase ab, damit Gäste/Paare statt
// eines Whitescreens einen sauberen Fehlerbildschirm sehen.
// (Suspense fängt nur Lazy-Loading, NICHT geworfene Fehler.)
// =====================================================================

import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Platzhalter für späteres Error-Tracking (z.B. Sentry).
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: "100dvh", display: "flex", alignItems: "center",
        justifyContent: "center", background: "var(--bg)",
        flexDirection: "column", gap: 16, padding: 24, textAlign: "center",
        fontFamily: "var(--font-body)",
      }}>
        <p style={{ fontFamily: "var(--font-display)", fontSize: "3rem", color: "var(--accent)" }}>✦</p>
        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 400, color: "var(--ink)", margin: 0 }}>
          Etwas ist schiefgelaufen
        </h1>
        <p className="wos-meta" style={{ maxWidth: 360 }}>
          Bitte lade die Seite neu. Falls das Problem bleibt, versuche es später erneut.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 8, padding: "10px 24px", border: "none", borderRadius: 999,
            background: "var(--accent)", color: "#fff", fontSize: 14, cursor: "pointer",
            fontFamily: "var(--font-body)",
          }}
        >
          Seite neu laden
        </button>
        <a href="/" style={{ color: "var(--accent)", textDecoration: "none", fontSize: 14 }}>
          ← Zur Startseite
        </a>
      </div>
    );
  }
}
